var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 104,
    viewBox: "0 0 100 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_104462",
    "data-name": "Group 104462",
    transform: "translate(1.032 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_146226",
    "data-name": "Rectangle 146226",
    transform: "translate(-0.032)",
    fill: "#83ffb9",
    stroke: "#29e67c",
    strokeWidth: 1,
    strokeDasharray: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 102,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 99,
    height: 103,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Two",
    transform: "translate(48.968 86)",
    fill: "#29e67c",
    fontSize: 10,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500,
    letterSpacing: "0em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.992,
    y: 0
  }, "Image")), /*#__PURE__*/React.createElement("g", {
    id: "add_photo_alternate_black_24dp",
    transform: "translate(22.072 10.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61965",
    "data-name": "Path 61965",
    d: "M0,0H54.259V54.259H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61966",
    "data-name": "Path 61966",
    d: "M39.173,13.3v6.76s-4.5.023-4.522,0V13.3H27.869s.023-4.5,0-4.522h6.782V2h4.522V8.782h6.782V13.3ZM32.39,22.347V15.565H25.608V8.782H7.522A4.535,4.535,0,0,0,3,13.3v27.13a4.535,4.535,0,0,0,4.522,4.522h27.13a4.535,4.535,0,0,0,4.522-4.522V22.347ZM7.522,40.433,14.3,31.39l4.522,6.782,6.782-9.043,9.043,11.3Z",
    transform: "translate(3.782 2.522)",
    fill: "#29e67c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDrag);
export default __webpack_public_path__ + "static/media/Image_drag.a38a4def589108994607706442c6b312.svg";
export { ForwardRef as ReactComponent };